import './App.css';
import TopBar from './components/TopBar';
import TopHero from './components/TopHero';
import HowItWorks from './components/HowItWorks';
import BetaCTA from './components/WaitlistCTA';
import SupportPanel from './components/SupportPanel';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <TopBar />
      <TopHero />
      <HowItWorks />
      <BetaCTA />
      {/* <section className="cta-support-row">
        <div className="container">
          <div className="cta-support-grid">
            <BetaCTA />
            <SupportPanel />
          </div>
        </div>
      </section> */}
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
